import { SWRConfiguration } from "swr";
import type { SWRInfiniteConfiguration } from "swr/dist/infinite";

export enum CACHE_KEYS {
  DEALER_GROUPS = "dealer_groups",
  REPORT_METRICS = "report_metrics",
  REPORTS = "reports",
  REPORTS_FILTERS = "reports-filters",
  SCANNING_PROGRESS = "scanning-progress",
  SCANNING_PROGRESS_FILTERS = "scanning-progress-filters",
  UNSCANNED_INVENTORY_PREVIEW = "unscanned-inventory-preview",
  BULK_TRIMS = "bulk-trims",
  VEHICLE_TRIMS = "vehicle-trims",
  DEVICES = "devices",
  UNREGISTERED_DEVICES = "unregistered-devices",
  DEVICES_FILTERS = "devices-filters",
  WIFI_CONFIGURATIONS = "wifi-configurations",
  USERS = "users",
  USERS_FILTERS = "users-filters",
  SUPPORTED_VEHICLES = "supported-vehicles",
  LOCATION = "location",
  UNSUBSCRIBE = "unsubscribe",
  OWNERSHIP_REPORT = "ownership_report",
  LEAD = "lead",
  VIN_VALIDATION = "vin-validation",
  VEHICLE_WIDGET_PAIR = "vehicle-widget-pair",
  CAMPAIGNS = "campaigns",
  YEAR_MAKE_MODEL = "year-make-model",
  DEALER_CONFIG = "dealer-config",
  CONFIGURATIONS = "configurations",
  CONFIGURATION_DETAIL = "configuration-detail",
}

export const swrConfig: SWRConfiguration = {
  errorRetryCount: 1,
  errorRetryInterval: 5000,
  dedupingInterval: 2000,
  revalidateOnReconnect: true,
  revalidateOnFocus: true,
  revalidateIfStale: false,
};

export const swrInfiniteConfig: SWRInfiniteConfiguration = {
  ...swrConfig,
  revalidateFirstPage: false,
};
